import React from 'react';
import { SingleSpanTable } from '../../SingleSpanTable';
import { getDOB } from 'components/account/jobs-v2/utils';
export const ECBSVRequestDataTable = ({ requestData }) => {
    let signatureType;
    switch (requestData.additionalParams?.signatureType) {
        case 'E':
            signatureType = 'Electronic Signature';
            break;
        case 'W':
            signatureType = 'Wet Signature';
            break;
        case undefined:
    }
    return (React.createElement(SingleSpanTable, { items: [
            {
                label: 'First Name',
                value: requestData.firstName
            },
            {
                label: 'Middle Name',
                value: requestData.middleName
            },
            {
                label: 'Last Name',
                value: requestData.lastName
            },
            {
                label: 'Date of Birth',
                value: getDOB(requestData.dateOfBirth)
            },
            {
                label: 'Signature Type',
                value: signatureType
            }
        ], numColumns: 2 }));
};
